import React from 'react';
import PropTypes from 'prop-types';
import { fieldInputPropTypes } from 'redux-form';
import TabField from "./TabField";
import { selectHandler, setAsChecked } from "./utils";
var TabFieldBlock = function TabFieldBlock(_ref) {
  var tabs = _ref.tabs,
    includeAll = _ref.includeAll,
    _ref$input = _ref.input,
    onChange = _ref$input.onChange,
    value = _ref$input.value;
  return /*#__PURE__*/React.createElement("div", {
    className: "form-group-tab-block",
    role: "radiogroup"
  }, tabs.map(function (_ref2) {
    var id = _ref2.id,
      name = _ref2.name,
      count = _ref2.count;
    return /*#__PURE__*/React.createElement(TabField, {
      key: id,
      name: name,
      count: count,
      selectTab: selectHandler(id, onChange, includeAll),
      checked: setAsChecked(id, value, includeAll)
    });
  }));
};
TabFieldBlock.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    count: PropTypes.number
  })).isRequired,
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  includeAll: PropTypes.bool
};
TabFieldBlock.defaultProps = {
  includeAll: false
};
export default TabFieldBlock;